import {XauditModel} from '../xaudit.model';

export class ScheduleBlockedTimesConfigurationModel extends XauditModel {
  SchedultTimeBlockID: string;
  LOCID: number;
  OperatoryID: string;
  enumWeekDaysID: string;
  StartTime: string;
  EndTime: string;
  ColorSchemeID: string;
  Reason: string;
}
